import { Requirements } from 'app/routes';

import { ModerationReason, setModerationReasons } from 'store/models/moderation';

export const ModerationReasonsListPageRequirements: Requirements<{
    moderationReasons: ModerationReason[];
}> = {
    methods: () => ({
        moderationReasons: { url: '/api/v1/catalog/moderation/reasons', cacheable: true },
    }),
    resolve: ({ result: { moderationReasons } }) => [setModerationReasons(moderationReasons)],
};
